'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'outlet';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e01c';
var svgPathData = 'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112 256c0 49.2 24.6 79.3 39.5 93.1 1.2 1.1 4.3 2.9 10.9 2.9l123.3 0c6.6 0 9.7-1.8 10.9-2.9 14.9-13.8 39.5-43.9 39.5-93.1s-24.6-79.3-39.5-93.1c-1.2-1.1-4.3-2.9-10.9-2.9l-123.3 0c-6.6 0-9.7 1.8-10.9 2.9-14.9 13.8-39.5 43.9-39.5 93.1zm-32 0c0-61.1 30.8-99.1 49.7-116.6 8.8-8.2 20.7-11.4 32.6-11.4l123.3 0c12 0 23.9 3.3 32.6 11.4 18.9 17.5 49.7 55.5 49.7 116.6s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4l-123.3 0c-12 0-23.9-3.3-32.6-11.4-18.9-17.5-49.7-55.5-49.7-116.6zm96-64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm-48 80c13.3 0 24 10.7 24 24l0 24-48 0 0-24c0-13.3 10.7-24 24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faOutlet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;